import { connect, useHistory } from 'umi';
import React from 'react';
import ContentBody from '@op/components/ContentBody';
import { Layout, Tabs, Button } from 'tea-component';
import './index.scss';
import { useFilterData } from './hooks/useFilterData';
import ModuleContent from './ModuleContent';
import CardCommon from '@op/components/CardCommon';
import useLanguage from '@op/hooks/useLanguage';
import { TabNavigator, useNavigatorScroll } from '@op/components/Navigator';
import { DBO_PAGE } from '@op/utils/format';
import { useAccountFilter } from '../hooks/useAccountFilter';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import { WeeklyReportVersionPerformance } from '@op/operationLog/pages';
import { useFontLoading } from '@op/hooks/common';
import useWeeklyReportPermission, {
  WeeklyReportContext,
} from '../hooks/permission';
import WeeklyReportDateSelect from '../components/WeeklyDateSelect';
import { PAGE_NAME } from '@op/constants/page';

const { Content } = Layout;

function VersionPerformance({ gameInfo, wholeGameInfo }: any) {
  useInitBuriedPointInfo({ buriedPoint: WeeklyReportVersionPerformance });
  const history = useHistory();
  const { formatMessage } = useLanguage();
  const { loading: timeChangeLoading, changeLoading } = useFontLoading();
  const {
    versionList,
    loading,
    moduleOptions,
    timeSelectOptions,
    effectiveTime,
    setEffectiveTime,
    tab,
    changeTabActive,
    allKeys,
    filter,
  } = useFilterData({
    gameInfo,
  });

  const { selectNavigator, setSelectNavigator, handleScroll, scrollBody } =
    useNavigatorScroll({
      allKeys,
      debounceTime: 10,
      watchAllKeys: true,
    });

  const { condLoading, exceptPrivateFilter } = useAccountFilter({ gameInfo });

  function clickToConfigPage() {
    history.push(
      '/opinion/CustomizedReports/WeeklyReport/VersionPerformance/Configuration',
    );
  }
  const { contextParams, canEditConfig } = useWeeklyReportPermission({
    gameInfo,
  });

  return (
    <WeeklyReportContext.Provider value={contextParams}>
      <Content
        ref={scrollBody}
        onScrollCapture={handleScroll}
        className="dbo-page dbo-version-performance"
      >
        <ContentBody
          className="dbo-version-performance-body"
          pageName={PAGE_NAME.VERSION_PERFORMANCE}
          contentHeard={
            <Content.Header
              className="dbo-header contentHead-normal"
              title={formatMessage(PAGE_NAME.VERSION_PERFORMANCE)}
              operation={
                canEditConfig && (
                  <Button onClick={() => clickToConfigPage()}>
                    {formatMessage('Configuration')}
                  </Button>
                )
              }
            >
              <div className="header-tab">
                <Tabs
                  ceiling
                  tabs={versionList as any}
                  animated={false}
                  activeId={tab}
                  onActive={(tab) => {
                    changeTabActive(tab);
                  }}
                />
              </div>
            </Content.Header>
          }
        >
          <CardCommon
            empty={versionList.length === 0}
            emptyHeight={150}
            loadingHeight={'calc(90vh - 90px)'}
            contentCard={versionList.length !== 0}
            loading={loading}
            hasEmptyImg={false}
            hasEmptyDesc={false}
            emptyTitleText="There are no weekly reports at the moment."
            emptyDescElement={formatMessage(
              'You can go to the [{Configuration}] to add a new weekly report.',
              {
                Configuration: canEditConfig ? (
                  <Button onClick={() => clickToConfigPage()} type="link">
                    {formatMessage('Configuration-1')}
                  </Button>
                ) : (
                  formatMessage('Configuration-1')
                ),
              },
            )}
          >
            <>
              {/* 时间选择器、 模块tab栏 */}
              <div className="dbo-version-performance-filter">
                <WeeklyReportDateSelect
                  defaultValue={effectiveTime}
                  onChange={(value: any) => {
                    setEffectiveTime(value);
                    changeLoading();
                  }}
                  options={timeSelectOptions}
                ></WeeklyReportDateSelect>

                {moduleOptions.length > 0 && (
                  <TabNavigator
                    options={moduleOptions}
                    value={selectNavigator}
                    scrollBody={scrollBody}
                    onChange={(value: string) => {
                      setSelectNavigator(value);
                      DBO_PAGE.scroll(value);
                    }}
                  ></TabNavigator>
                )}
              </div>
              {/* 模块内容 */}
              <CardCommon
                contentCard
                loading={timeChangeLoading}
                loadingHeight={500}
              >
                {moduleOptions.map((item) => (
                  <ModuleContent
                    key={item.value}
                    moduleName={item.text}
                    moduleId={item.moduleId}
                    moduleKeyWords={item.keywords}
                    filter={filter}
                    gameInfo={gameInfo}
                    wholeGameInfo={wholeGameInfo}
                    tags={item.tags}
                    condLoading={condLoading}
                    feedsFilter={exceptPrivateFilter}
                  ></ModuleContent>
                ))}
              </CardCommon>
            </>
          </CardCommon>
        </ContentBody>
      </Content>
    </WeeklyReportContext.Provider>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(VersionPerformance);
